export const getAllPublishableConceptRefs = (entities) => {
  let allConceptRefs = [];
  const organizations = _.filter(entities, function (entity) {
    return entity.ent_type === "Organization"
  });
  organizations.forEach(organization => allConceptRefs = allConceptRefs.concat(organization.publishable_concept_refs));
  allConceptRefs = allConceptRefs.filter((value, index, self) => self.indexOf(value) === index);
  return allConceptRefs;
};
